import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            id: 0,
            expireDate: null,
            restOfTraining: '',
            rec: false,
            prices: {
                gasoline: 0,
                diesel: 0,
                methane: 0,
                tng: 0,
                electric: 0,
            },
            model: {
                id: '',
                autoRecommendationEnabled: false,
                isNightShiftEnabled: false,
                sendSmsToNewCustomersEnabled: false,
                assignedOrdersLimit: 0,
                orderPreparationTimeLimitInMinutes: 0,
                orderCancellationTimePeriodInMinutes: 0,
                deliveryPricePerKilometer: 0,
                preparationTime: 0,
                ownVehiclePrice: 0,
                bicycleVehiclePrice: 0,
                companyVehiclePrice: 0,
                addPriceToNightShift: 0,
                greenVoucher: 0,
                blueVoucher: 0,
                whiteVoucher: 0,
            },
            discounts: {
                priceForCity: 0
            }
        }
    },
    methods: {
        load:load,
        checkNull:checkNull,
        isVisiblePrice:isVisiblePrice,
        update:update,
        resetPassword: resetPassword,
        visibleDevelop: visibleDevelop,
        formatDate:formatDate
    },
    beforeMount() {
        if(session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }
        this.load()
    }
}

function load() {
    let _self = this;
    AdminApiService.getConfiguration()
        .then((response) => {
            _self.model.id = response.data.id;
            _self.rec = response.data.autoRecommendationEnabled;
            console.log("value: configuration: "+ _self.rec);
            _self.model.autoRecommendationEnabled = response.data.autoRecommendationEnabled;
            _self.model.sendSmsToNewCustomersEnabled = response.data.sendSmsToNewCustomersEnabled != null ? response.data.sendSmsToNewCustomersEnabled : false ;
            _self.model.assignedOrdersLimit = response.data.assignedOrdersLimit;
            _self.model.orderPreparationTimeLimitInMinutes = response.data.orderPreparationTimeLimitInMinutes;
            _self.model.orderCancellationTimePeriodInMinutes = response.data.orderCancellationTimePeriodInMinutes;
            _self.model.preparationTime = response.data.preparationTime;
            _self.model.ownVehiclePrice = response.data.ownVehiclePrice;
            _self.model.bicycleVehiclePrice = response.data.bicycleVehiclePrice;
            _self.model.companyVehiclePrice = response.data.companyVehiclePrice;
            _self.model.greenVoucher = response.data.vouchers.green;
            _self.model.blueVoucher = response.data.vouchers.blue;
            _self.model.whiteVoucher = response.data.vouchers.white;
            _self.model.deliveryPricePerKilometer = response.data.deliveryPricePerKilometer != null ? response.data.deliveryPricePerKilometer : 0
            _self.model.isNightShiftEnabled = response.data.isNightShiftEnabled != null ? response.data.isNightShiftEnabled : false
            _self.model.addPriceToNightShift = response.data.addPriceToNightShift != null ? response.data.addPriceToNightShift : 0
            _self.discounts.priceForCity = response.data.discounts.priceForCity != null ? response.data.discounts.priceForCity : 0;
        })
        .catch(error => {
            swal('Greška', error.data.message, 'error')
        })

    AdminApiService.getCurrenFuelPrice()
        .then((response) => {
            if(response.data.length > 0){
                _self.prices = response.data[0]
            }
        })
        .catch(error => {
            swal('Greška', error.data.message, 'error')
        })
}

function update() {
    let _self = this;
    let newModel = {
        autoRecommendationEnabled: _self.model.autoRecommendationEnabled,
        sendSmsToNewCustomersEnabled: _self.model.sendSmsToNewCustomersEnabled,
        assignedOrdersLimit: _self.model.assignedOrdersLimit,
        orderPreparationTimeLimitInMinutes: _self.model.orderPreparationTimeLimitInMinutes,
        orderCancellationTimePeriodInMinutes: _self.model.orderCancellationTimePeriodInMinutes,
        preparationTime: _self.model.preparationTime,
        ownVehiclePrice: _self.model.ownVehiclePrice,
        bicycleVehiclePrice: _self.model.bicycleVehiclePrice,
        companyVehiclePrice: _self.model.companyVehiclePrice,
        isNightShiftEnabled: _self.model.isNightShiftEnabled,
        addPriceToNightShift: parseInt(_self.model.addPriceToNightShift),
        deliveryPricePerKilometer: parseInt(_self.model.deliveryPricePerKilometer),
        vouchers: {
            green: _self.model.greenVoucher,
            blue: _self.model.blueVoucher,
            white: _self.model.whiteVoucher,
        },
        discounts: {
            priceForCity: parseFloat(_self.discounts.priceForCity)
        }
    }
    if(newModel.vouchers.green === '' || newModel.vouchers.green === '0' || newModel.vouchers.green === 0 ||
        newModel.vouchers.blue === '' || newModel.vouchers.blue === '0' ||  newModel.vouchers.blue === 0 ||
        newModel.ownVehiclePrice === '' || newModel.ownVehiclePrice === '0' || newModel.ownVehiclePrice === 0 ||
        newModel.bicycleVehiclePrice === '' || newModel.bicycleVehiclePrice === '0' || newModel.bicycleVehiclePrice === 0 ||
        newModel.companyVehiclePrice === '' || newModel.companyVehiclePrice === '0' || newModel.companyVehiclePrice === 0){
        swal('Greška', 'Neke vrednosti nisu validne', 'error')
        return;
    }

    if(this.prices.gasoline === 0 || this.prices.diesel === 0 || this.prices.methane === 0 || this.prices.tng === 0){
        swal('Greška', 'Cene goriva ne smeju biti 0', 'error')
        return;
    }

    if(newModel.deliveryPricePerKilometer <= 0){
        swal('Greška', 'Postavite cenu po kilometru', 'error')
        return;
    }

    AdminApiService.updateConfiguration(newModel, _self.model.id)
        .then((response) => {
            swal('Uspešno', 'Uspešno izmenjena konfiguracija.', 'success')
            _self.load();
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })

    let newPrices = {
        gasoline: _self.prices.gasoline,
        diesel: _self.prices.diesel,
        methane: _self.prices.methane,
        tng: _self.prices.tng,
        electric: _self.prices.electric,
        time: Date.now()
    }
    console.log(newPrices)
    AdminApiService.updateFuelPrices(newPrices)
        .then((response) => {
            _self.load();
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })


}

function resetPassword() {
    this.$router.push('/reset-password');
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function checkNull(data) {
    if(data == null) return '';
    return data;
}

function isVisiblePrice(){
    return session.getRole() === 'ADMIN'
}

function visibleDevelop() {
    return localStorage.getItem('sb95') === 'braca'
}


// WEBPACK FOOTER //
// ./src/components/Configuration/Configuration.js